module.exports = __webpack_public_path__ + "static/media/matching-score-rank-2.9bde3adf.png";